import { ProspectsService } from '@api'
import { useMutation, useQueryClient } from 'react-query'

import { useToast } from '@/components/ui/toast.tsx'
import { handleError } from '@/utils/error'

interface EditProspectBody {
  id: number
  name: string
  website: string
  country: string
}

export const useEditProspect = () => {
  const queryClient = useQueryClient()
  const toast = useToast()

  const editMutation = useMutation(
    (body: EditProspectBody) =>
      ProspectsService.updateProspect({ requestBody: body, id: body.id }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['prospects'])
        toast.success('Prospect updated successfully')
      },
      onError: (error) => {
        handleError(error, 'Failed to update prospect')
      },
    },
  )

  return {
    editProspect: editMutation.mutateAsync,
    isEditingProspect: editMutation.isLoading,
  }
}
